
import { defineStore } from 'pinia'
import { IndexDBStore } from '@/types'
import IndexDB, { StoreType } from '@/utils/indexDB'

export default () => defineStore('indexDB', {
  state: ():IndexDBStore => ({
    IndexDB: null
  }),
  getters: {
    // collapsed: (state) => state.collapsed,
  },
  actions: {
    setIndexDB(payload: IndexDB<StoreType | StoreType[]>) {
      if (payload) {
        this.IndexDB = payload
        this.IndexDB.isReady = true
        return this.IndexDB
      }
      return null
    }
  }
})
